// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DvLRj","colBig":"styles_colBig__2kjvL","colSmall":"styles_colSmall__CnASm"};